import React, {memo, useCallback, useEffect, useMemo, useState} from "react"
import {Container} from "../../../components/Container"
import {PhaseField} from "../components/PhaseField"
import {doughnutDatas, doughnutOptions} from "../settings/options"
import {Doughnut} from "react-chartjs-2"
import {useDispatch, useSelector} from "react-redux"
import {C} from "../utils/calculate"
import {useHistory} from "react-router-dom"
import {backButtonToggle} from "../../../store/ui/actions"
import {PhaseModel} from "../types/types"
import useChartLoader from "../hooks/chart-loader"
import "./index.scss"
import fullscreen from "../../../assets/images/icons/fullscreen.png"

const BACK_URL = "/energy"
export const EnergyConsumption = memo(function EnergyConsumption() {
    const history = useHistory()
    const energyUpdated = useSelector(state => state.control.energyUpdated)
    const energyControlList = useSelector(state => state.control.energyState)
    const controls = useSelector(state => state.control.controlList)
    const controlList = controls.filter(control => control.type_id === "200")
    const maxValue = Number(energyControlList.max_point)
    const dispatch = useDispatch()
    const {isLoaded, loading} = useChartLoader()
     const Phases: PhaseModel[] = useMemo(() => controlList, [controlList])
     const [selectedPhase, setSelectedPhase] = useState({
         id: Phases[0]?.id || undefined,
         selected: true
     })

    const realtimeEnergy = useSelector(
        state => state.control.controlList.find(r => r?.id === selectedPhase?.id)?.parameters["realtime_energy"]
    )
    const energyUpdatedCheck = useMemo(
        () => (energyUpdated?.energy_value === null ? Number(realtimeEnergy) : Number(energyUpdated?.energy_value)),
        [energyUpdated, realtimeEnergy]
    )
    const [valueInput, setValueInput] = useState<any>(energyUpdatedCheck)
    const [defaultValue, setDefaultValue] = useState(0)
    const [defaultColor, setDefaultColor] = useState(null)
    dispatch(backButtonToggle({is_open: true, to: "/energy"}))
    const chartData = doughnutDatas(valueInput, defaultValue, defaultColor)


    const onClickPhaseChanging = useCallback(
        (id: string) => {
            Phases.find(
                phase =>
                    phase.id === id &&
                    setSelectedPhase({
                        id: id,
                        selected: true
                    })
            )
        },
        [Phases]
    )
    /*const onClickAllPhase = useCallback(
        () =>
            setSelectedPhase({
                id: undefined,
                selected: false
            }),
        []
    )*/

    useEffect(() => {
        let dataGraphic = valueInput
        let defaultdataGraphic = defaultValue
        let dataColor = defaultColor
        if (dataGraphic <= maxValue && dataGraphic >= 0) {
            defaultdataGraphic = maxValue - dataGraphic
            if (dataGraphic >= 0 && dataGraphic <= C(maxValue, 7)) {
                dataColor = "rgba(81, 243, 51, 1)"
            } else if (dataGraphic >= C(maxValue, 7) + 1 && dataGraphic <= C(maxValue, 6)) {
                dataColor = "rgba(197, 245, 61, 1)"
            } else if (dataGraphic >= C(maxValue, 6) + 1 && dataGraphic <= C(maxValue, 5)) {
                dataColor = "rgba(252, 196, 38, 1)"
            } else if (dataGraphic >= C(maxValue, 5) + 1 && dataGraphic <= C(maxValue, 4)) {
                dataColor = "rgba(252, 143, 38, 1)"
            } else if (dataGraphic >= C(maxValue, 4) + 1 && dataGraphic <= C(maxValue, 3)) {
                dataColor = "rgba(246, 97, 39, 1)"
            } else if (dataGraphic >= C(maxValue, 3) + 1 && dataGraphic <= C(maxValue, 2)) {
                dataColor = "rgba(236, 65, 18, 1)"
            } else if (dataGraphic >= C(maxValue, 2) + 1 && dataGraphic <= maxValue) {
                dataColor = "rgba(255, 0, 0, 1)"
            }
        } else {
            dataGraphic = maxValue
            defaultdataGraphic = 0
            dataColor = "rgba(255, 0, 0, 1)"
        }
        setDefaultValue(defaultdataGraphic)
        setDefaultColor(dataColor)
        setValueInput(energyUpdatedCheck)
    }, [defaultColor, defaultValue, valueInput, energyUpdatedCheck, maxValue, selectedPhase])

    return (
        <Container>
            <div className="page-wrapper">
                <div className="energy-wrapper">
                    <div className="energy-page-container">
                        <PhaseField
                            selectedPhase={selectedPhase}
                            //onClickAllPhase={onClickAllPhase}
                            onClickPhaseChanging={onClickPhaseChanging}
                        />
                    </div>
                    <div className="energy-page-full-screen-container">
                        <div className="energy-page-full-screen" onDoubleClick={() => history.push(BACK_URL)}>
                            {loading && (
                                <div className="chart-spin-container">
                                    <div className="chart-spin" />
                                </div>
                            )}
                            <div className="fullscreen-doughnut-chart" style={isLoaded}>
                                <Doughnut data={chartData} options={doughnutOptions} />
                                <span>{valueInput.toFixed(2)}</span>
                                <span>kW</span>
                                <div className="doughnut-maxvalue">
                                    <span>0</span>
                                    <span>{maxValue}</span>
                                </div>
                            </div>
                            <img className="fullscreen-consumption" src={fullscreen} alt="" onClick={() => history.push(BACK_URL)}/>
                        </div>
                    </div>
                </div>
            </div>
        </Container>
    )
})
